import api from './api';

export interface TimeSlot {
  id: number;
  student: number;
  day: string;
  start_time: string;
  end_time: string;
  created_at: string;
  updated_at: string;
}

class TimeSlotService {
  async getAll(params?: any): Promise<TimeSlot[]> {
    const response = await api.get('/time-slots/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getByStudent(studentId: number): Promise<TimeSlot[]> {
    const response = await api.get('/time-slots/', { params: { student: studentId } });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getTimeSlot(id: number): Promise<TimeSlot> {
    const response = await api.get(`/time-slots/${id}/`);
    return response.data;
  }

  async create(data: Partial<TimeSlot>): Promise<TimeSlot> {
    const response = await api.post('/time-slots/', data);
    return response.data;
  }

  async update(id: number, data: Partial<TimeSlot>): Promise<TimeSlot> {
    const response = await api.patch(`/time-slots/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/time-slots/${id}/`);
  }
}

const timeSlotService = new TimeSlotService();
export default timeSlotService;
